import React from "react";
import { inject, observer } from "mobx-react";
import ToggleButtonGroup from "../toggleButtonGroup/toggleButtonGroup";
import { ClientStore } from "../../../stores/clientStore";
import { maxNumberOfInsureds } from "../../../helpers/client";
import { yesNo } from "../../../helpers/yesNo";
import { CalculationService } from "../../../services/services/calculationService";
import { runInAction } from "mobx";

interface IsInsurerAlsoInsuredProps {
    clientStore?: ClientStore;
    calculationService?: CalculationService;
    disabled?: boolean;
}

export function IsInsurerAlsoInsured(props: IsInsurerAlsoInsuredProps) {
    const clientStore = props.clientStore!;

    const question = {
        text: "Czy Ubezpieczający jest osobą na rzecz której zawierana jest umowa (czy jest Ubezpieczonym)?",
        setValue(newValue: string) {
            runInAction(() => {
                // TODO: create setter and remove 'runInAction'
                clientStore.insurer.insured = newValue === yesNo.yes;
            });
            if (clientStore.insureds.length === 0) {
                clientStore.addInsured();
            }
        }
    };

    const disabled = (clientStore.insureds.length === maxNumberOfInsureds && setToggleButtonValue() === yesNo.no) || props.disabled;

    return (
        <div className="insurer-also-insured">
            <ToggleButtonGroup question={question.text}
                options={[
                    {
                        value: yesNo.yes,
                        label: "tak"
                    },
                    {
                        value: yesNo.no,
                        label: "nie"
                    }
                ]}
                value={setToggleButtonValue()}
                onChange={(newValue: string) => {
                    question.setValue(newValue);
                    props.calculationService!.setRisksNetworkForAllPackages();
                }}
                disabled={disabled}
            />

        </div>
    );

    function setToggleButtonValue() {
        const isInsurerAlsoInsured = clientStore.insurer.insured;
        if (isInsurerAlsoInsured === undefined) {
            return undefined;
        }
        return isInsurerAlsoInsured ? yesNo.yes : yesNo.no;
    }
}

export default inject("clientStore", "calculationService")(observer(IsInsurerAlsoInsured));
